import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="18" height="18" rx="9" fill="#2D374B" />
    <path
      d="M10.4888 8.46701L11.4251 6.87843L13.9485 10.8089L13.9497 11.5631L13.9415 6.37266C13.9355 6.24578 13.8682 6.12971 13.7607 6.06127L9.21745 3.44794C9.11118 3.39572 8.9764 3.39627 8.87033 3.44956C8.85601 3.45676 8.84252 3.46456 8.82966 3.47306L8.81383 3.48303L4.40391 6.03856L4.38677 6.04631C4.36478 6.05644 4.34254 6.0693 4.32166 6.08425C4.23806 6.14423 4.18252 6.23289 4.16455 6.33235C4.16186 6.34742 4.15989 6.36277 4.15894 6.37824L4.16586 10.608L6.51637 6.96479C6.8123 6.4817 7.45709 6.3261 8.05562 6.33456L8.75813 6.35312L4.61897 12.9912L5.10689 13.2721L9.29566 6.35984L11.1471 6.35312L6.96912 13.4398L8.71018 14.4412L8.9182 14.5608C9.00619 14.5966 9.10992 14.5984 9.19866 14.5664L13.8057 11.8965L12.9249 12.4069L10.4888 8.46701ZM10.846 13.6117L9.08753 10.8517L10.161 9.03018L12.4704 12.6703L10.846 13.6117Z"
      fill="#2D374B"
    />
    <path
      d="M9.08752 10.8517L10.846 13.6116L12.4705 12.6702L10.161 9.03015L9.08752 10.8517Z"
      fill="#28A0F0"
    />
    <path
      d="M13.9497 11.5631L13.9485 10.8089L11.425 6.87842L10.4888 8.467L12.9249 12.4069L13.8057 11.8965C13.8921 11.8264 13.9443 11.7234 13.9498 11.6122L13.9497 11.5631Z"
      fill="#28A0F0"
    />
    <path
      d="M3.37504 12.2744L4.61888 12.9911L8.75804 6.35311L8.05554 6.33455C7.457 6.32609 6.81225 6.48169 6.51629 6.96478L4.16577 10.608L3.375 11.823V12.2744H3.37504Z"
      fill="white"
    />
    <path
      d="M11.1471 6.35309L9.29571 6.35981L5.10693 13.2721L6.57102 14.1151L6.96917 13.4398L11.1471 6.35309Z"
      fill="white"
    />
    <path
      d="M14.7298 6.34358C14.7144 5.95639 14.5047 5.60191 14.1763 5.39555L9.57358 2.74864C9.24873 2.58505 8.8429 2.58485 8.51754 2.74852C8.47909 2.7679 4.04143 5.34159 4.04143 5.34159C3.98003 5.37102 3.92088 5.40611 3.86522 5.44591C3.57206 5.65603 3.39336 5.9825 3.375 6.34121V11.823L4.16577 10.608L4.15885 6.37828C4.1598 6.36281 4.16174 6.34762 4.16447 6.33258C4.18231 6.23304 4.23789 6.14427 4.32157 6.08429C4.34246 6.06934 8.85588 3.4568 8.87024 3.4496C8.97635 3.39631 9.11114 3.39576 9.21736 3.44798L13.7606 6.06131C13.8681 6.12975 13.9354 6.24582 13.9414 6.3727V11.6123C13.9359 11.7234 13.892 11.8264 13.8056 11.8965L12.9248 12.4069L12.4703 12.6703L10.8459 13.6117L9.19853 14.5664C9.10979 14.5985 9.00606 14.5967 8.91807 14.5609L6.969 13.4398L6.57084 14.1151L8.32242 15.1236C8.38034 15.1565 8.43197 15.1857 8.4743 15.2095C8.5399 15.2463 8.58456 15.2709 8.60035 15.2785C8.72485 15.3389 8.90395 15.3741 9.06536 15.3741C9.21337 15.3741 9.35765 15.347 9.49422 15.2935L14.2791 12.5224C14.5537 12.3097 14.7153 11.9888 14.7298 11.6411V6.34358Z"
      fill="#96BEDC"
    />
  </svg>
)
